import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import './About.css';

function About() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    client.fetch('*[_type == "about"][0]').then(data => {
      if (data) setAbout(data);
    });
  }, []);

  const title = (about && about.title) || 'GARDEN POÈTE';
  const heritage = (about && about.heritage) || 'Since 2019';
  const mainImage = about && about.mainImage;
  const storyParagraphs = (about && about.storyParagraphs) || [
    '6년 동안, 이곳은 홍대 골목 안쪽 숨은 공간이었습니다.',
    '친구들이 와인을 마시며 이야기를 나누고, 페어리 라이트가 평범한 저녁을 마법으로 바꾸는 곳.',
    '사람들은 이곳에서 사랑에 빠졌습니다. 음식에, 분위기에, 그리고 때로는 서로에게.',
  ];
  const transitionHeading = (about && about.transitionHeading) || "이제, 새로운 이야기를 씁니다.";
  const visionParagraphs = (about && about.visionParagraphs) || [
    'Garden Poète는 당신이 사랑했던 모든 것을 이어갑니다. 노란 집, 페어리 라이트가 흔들리는 정원, 다른 세계로 들어선 듯한 느낌.',
    '하지만 이제 우리는 이곳이 가장 잘하는 것에 집중합니다. 당신에게 가장 소중한 사람들을 위한, 잊을 수 없는 순간을 만드는 일.',
  ];
  const visionClosing = (about && about.visionClosing) || '같은 마음. 같은 마법.\n이제, 당신의 가장 중요한 날을 위해.';
  const philosophyHeading = (about && about.philosophyHeading) || '우리가 믿는 것';
  const philosophyParagraphs = (about && about.philosophyParagraphs) || [
    '가장 좋은 결혼식은 가장 큰 결혼식이 아닙니다. 나무 사이로 웃음소리가 울려 퍼지고, 모든 손님이 가족처럼 느껴지는 결혼식.',
    '이곳은 단순한 장소가 아닙니다.\n당신의 이야기가 펼쳐지는 곳. 조용히, 친밀하게, 당신만이 쓸 수 있는 시처럼.',
  ];

  return (
    <div className="about">
      <SEO
        title="가든포에트 이야기"
        description="2019년부터 이어온 가든포에트의 이야기. 카페에서 웨딩 공간으로, 사람들이 함께하는 순간의 소중함을 지켜온 6년의 기록."
        path="/about"
      />
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content fade-in">
            <h1>{title}</h1>
            <p className="heritage">{heritage}</p>
            {mainImage && (
              <div style={{ marginTop: '2rem' }}>
                <img 
                  src={urlFor(mainImage).width(800).url()} 
                  alt={title}
                  style={{ width: '100%', maxWidth: '800px', height: 'auto', borderRadius: '8px' }}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content fade-in">
            {storyParagraphs.map(function(p, i) {
              return <p key={i} className="story-paragraph">{p}</p>;
            })}
          </div>
        </div>
      </section>

      <section className="about-transition">
        <div className="container">
          <div className="transition-content fade-in">
            <h2>{transitionHeading}</h2>
          </div>
        </div>
      </section>

      <section className="about-vision">
        <div className="container">
          <div className="vision-content fade-in">
            {visionParagraphs.map(function(p, i) {
              return <p key={i} className="vision-paragraph">{p}</p>;
            })}
            <p className="vision-closing">
              {visionClosing.split('\n').map(function(line, i) {
                return <React.Fragment key={i}>{i > 0 && <br />}{line}</React.Fragment>;
              })}
            </p>
          </div>
        </div>
      </section>

      <section className="about-philosophy">
        <div className="container">
          <div className="philosophy-content fade-in">
            <h3>{philosophyHeading}</h3>
            {philosophyParagraphs.map(function(p, i) {
              return (
                <p key={i}>
                  {p.split('\n').map(function(line, j) {
                    return <React.Fragment key={j}>{j > 0 && <br />}{line}</React.Fragment>;
                  })}
                </p>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
